import { DayOfWeek, Instant, LocalDate, LocalDateTime, LocalTime, ZoneId } from "@js-joda/core";
import { globalize } from "../../../translate";

export function getFormattedArrivalTime(now: LocalDateTime | Instant) {
  const asLocalDateTime =
    now instanceof Instant ? LocalDateTime.ofInstant(now, ZoneId.of("America/New_York")) : now;
  return globalize().formatLocalDateTime(getInstapayArrivalTime(asLocalDateTime), {
    datetime: "short",
  });
}

export function getInstapayArrivalTime(now: LocalDateTime) {
  if ([DayOfWeek.SATURDAY, DayOfWeek.SUNDAY].includes(now.dayOfWeek())) {
    return getNextDayOfWeek(now.toLocalDate(), DayOfWeek.MONDAY).atTime(LocalTime.of(12, 30));
  }

  if (now.hour() <= 10) {
    return LocalDateTime.from(now.toLocalDate().atTime(LocalTime.of(12, 30)));
  }

  if (now.hour() < 16) {
    return LocalDateTime.from(now.toLocalDate().atTime(LocalTime.of(18, 30)));
  }

  const nextDay =
    now.dayOfWeek() === DayOfWeek.FRIDAY
      ? getNextDayOfWeek(now.toLocalDate(), DayOfWeek.MONDAY)
      : now.toLocalDate().plusDays(1);

  return LocalDateTime.from(nextDay.atTime(LocalTime.of(12, 30)));
}

function getNextDayOfWeek(date: LocalDate, dayOfWeek: DayOfWeek): LocalDate {
  if (date.dayOfWeek() === dayOfWeek) {
    return date;
  }

  return getNextDayOfWeek(date.plusDays(1), dayOfWeek);
}
